"use client";
import React, { ChangeEvent } from "react";
import { UseFormRegisterReturn } from "react-hook-form";
import { isEmpty } from "../../../utils";

interface TextAreaProps {
  styleWrapper?: string;
  errorMessage?: string;
  id?: string;
  isError?: boolean;
  labelBottom?: string;
  labelTop?: string;
  name?: string;
  onchange?: (e: ChangeEvent<HTMLTextAreaElement>) => void;
  register?: UseFormRegisterReturn<any> | null;
  value?: string;
}

const TextArea: React.FC<TextAreaProps> = ({
  styleWrapper = "mt-16",
  errorMessage,
  id,
  isError = false,
  labelBottom,
  labelTop,
  name,
  onchange,
  register,
  value,
}): JSX.Element => {
  const classNameLabelBottom = `text-[14px] ${
    isError ? "text-[#FF0000]" : "text-[#999999]"
  }`;

  return (
    <div className={`flex flex-col gap-2 ${styleWrapper}`}>
      <label className="text-[16px] font-bold">{labelTop}</label>

      {!register && (
        <textarea
          className="w-full p-2 border rounded-md text-lg focus:outline-none border-[#CCC] focus:border-[#001049]"
          id={id}
          name={name}
          onChange={onchange}
          value={value}
        />
      )}

      {register && (
        <textarea
          className="w-full p-2 border rounded-md text-lg focus:outline-none border-[#CCC] focus:border-[#001049]"
          defaultValue={value}
          id={id}
          {...register}
        />
      )}

      {(!isEmpty(labelBottom) || !isEmpty(errorMessage)) && (
        <p className={classNameLabelBottom}>
          {isError ? errorMessage : labelBottom}
        </p>
      )}
    </div>
  );
};

export default TextArea;
